import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * A token for skipping the loader in the UI for an HTTP context
 */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

/**
 * Sets the SKIP_LOADER flag in the given HTTP context
 *
 * @param context - The HTTP context to modify
 * @returns The modified HTTP context
 */
export const skipLoader = (context: HttpContext): HttpContext => context.set(SKIP_LOADER, true);
